import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector:    'app-dialer',
  templateUrl: './dialer.component.html',
  styles:      [],
})
export class DialerComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
